<template>
  <div>
    <v-card-title class="dialog_header">{{ formTitle }}</v-card-title>
    <v-card-text>
      <v-form @submit.prevent="handleSubmit">
        <formWrapper :validator="$v.form">
          <v-container>
            <v-row>
              <v-col cols="12">
                <locale-select
                  v-if="isEdit"
                  v-model="locale"
                  @change="changeLocale"
                />

                <new-image-upload
                  class="file-upload__image mb-5"
                  :imgUrl="form.photo ? form.photo.path : ''"
                  :imgId="isEdit && form.photo ? form.photo.id : ''"
                  :reset="resetImage"
                  @fileSelected="handleImageSelect"
                  @ImageUpdated="handleImageUpdate"
                  :maxSize="maxSize"
                />

                <form-group name="name" attribute="fields.name">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      outlined
                      v-model="form.name"
                    ></v-text-field>
                  </template>
                </form-group>
                <form-group name="code" attribute="fields.code">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      outlined
                      v-model="form.code"
                    ></v-text-field>
                  </template>
                </form-group>
                <form-group name="phone_code" attribute="fields.phone_code">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      type="number"
                      v-bind="attrs"
                      v-on="listeners"
                      outlined
                      v-model="form.phone_code"
                    ></v-text-field>
                  </template>
                </form-group>
              </v-col>

              <v-col cols="12">
                <v-btn
                  :loading="loadingButton"
                  type="submit"
                  :disabled="$v.form.$invalid"
                  class="primary"
                  >{{ textButton }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </formWrapper>
      </v-form>
    </v-card-text>
  </div>
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { ShowData } from "@/helpers/apiMethods";
import cookie from "js-cookie";
export default {
  name: "FormAction",

  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    dialog: {
      type: Boolean,
      default: false
    },
    table_ref: {
      type: Object,
      default: () => {}
    },
    item: {
      type: Object,
      default: () => {}
    },
    index: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      maxSize: 1.24,
      resetImage: false,
      form: {
        name: "",
        code: "",
        photo: "",
        phone_code: ""
      },
      imageFile: "",
      reset: false,
      loadingButton: false,
      locale: this.locale
    };
  },
  computed: {
    formTitle() {
      if (this.isEdit) {
        return this.$t("headings.edit");
      } else {
        return this.$t("headings.create");
      }
    },
    textButton() {
      if (!this.isEdit) {
        return this.$t("button.create");
      } else {
        return this.$t("button.edit");
      }
    }
  },
  watch: {
    dialog: {
      handler(value) {
        if (!value) {
          this.resetData();
          this.$emit("dialog_close");
          setTimeout(() => {
            this.resetImage = false;
          }, 1000);
        }
      },
      immediate: true
    },
    isEdit: {
      handler(value) {
        if (value) {
          this.handleShowData();
        }
      },
      immediate: true
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(50)
      },
      phone_code: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(6)
      },
      code: {
        required,
        maxLength: maxLength(2)
      },
      photo: {
        required
      }
    }
  },
  methods: {
    handleImageUpdate(photo) {
      this.$emit("update_main_image", photo);
    },
    handleImageSelect(photo) {
      if (!this.isEdit) {
        this.form.photo = photo.file;
      } else {
        this.imageFile = photo.file;
      }
    },
    hanleRefreshTable() {
      this.table_ref.handleGetItems(this.$route.query);
    },
    changeLocale(locale) {
      this.locale = locale;
      this.handleShowData(locale);
    },

    resetData() {
      this.$v.form.$reset();
      this.resetImage = true;
      this.form = {};
      this.reset = true;
      this.loadingButton = false;
      this.locale = cookie.get("language");
    },
    handleSubmit() {
      this.loadingButton = true;
      const formData = new FormData();
      if (this.isEdit) delete this.form.photo;
      Object.keys(this.form).forEach(formKey => {
        formData.append(formKey, this.form[formKey]);
      });
      if (!this.isEdit) {
        // in case create
        this.table_ref
          .handleOnCreate(`countries`, formData, "country")
          .finally(() => {
            this.loadingButton = false;
          });
      } else {
        // in case edit
        formData.append("_method", "put");
        formData.append("locale", this.locale);
        this.table_ref
          .handleOnEdit(
            `countries`,
            formData,
            this.item.id,
            "country",
            this.index
          )
          .finally(() => (this.loadingButton = false));
      }
    },
    handleShowData(locale = this.locale) {
      ShowData({
        reqName: `countries`,
        param: this.item.id,
        locale
      })
        .then(res => {
          const { country } = res.data;
          this.form = {
            ...country,
            photo: country.flag
          };
        })
        .catch(err => console.log(err));
    }
  }
};
</script>
